import React, { Component } from 'react'
import { Card, RadioGroup, Radio, Popover, Position, Toaster, Button, Alert } from '@blueprintjs/core'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'

import Cookies from 'universal-cookie'

import {
    moveUpAction,
    moveDownAction,
    moveLeftAction,
    moveRightAction,
    moveSecretAction,
    endTurnAction,
    startGameAction,
    suggestAction,
    accuseAction,
} from '../actions/playerActions'

const NavbarToaster = Toaster.create({
    className: 'playerTokenToaster',
    position: Position.BOTTOM_RIGHT
})

const cookies = new Cookies()

class Navbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            accuse: false,
            weapon: 'candlestick',
            room: 'dining room',
            character: 'mr. green',
            player: '',
            checkMyCards: false,
        }
    }

    startGame = () => {
        this.props.dispatch(
            startGameAction()
        )
    }

    setPlayerName = (name) => {
        /*this.props.dispatch(
            setPlayerName( name )
        )*/
    }

    moveUp = () => {
        this.props.dispatch(
            moveUpAction(this.props.activePlayer) 
        )
    }

    moveDown = () => {
        this.props.dispatch(
            moveDownAction(this.props.activePlayer)
        )
    }

    moveLeft = () => {
        this.props.dispatch(
            moveLeftAction(this.props.activePlayer)
        )
    }

    moveRight = () => {
        this.props.dispatch(
            moveRightAction(this.props.activePlayer)
        )
    }

    moveSecret = () => {
        this.props.dispatch(
            moveSecretAction(this.props.activePlayer)
        )
    }

    endTurn = () => {
        this.props.dispatch(
            endTurnAction(this.props.activePlayer)
        )
    }

    suggestPlayer = () => {
        let activePlayer = this.props.players[this.props.activePlayer]
        // Suggest route which will tell you if someone has a card
        if(this.props.suggested) {
            NavbarToaster.show({
                message: "You've already made one suggestion this turn.  You cannot make another."
            })        
        } else {
            this.props.dispatch( 
                suggestAction( this.state.weapon, this.props.room_coords[ activePlayer.position[0].toString() + activePlayer.position[1].toString() ].toLowerCase(), this.state.character, this.state.player )
            )
        }
        this.setState({ accuse: false })
    }

    accusePlayer = () => {
        // Accuse route YOU MIGHT WIN OR LOSE THIS IS BIG
        let activePlayer = this.props.players[this.props.activePlayer] 
        if(this.props.accused) {
            NavbarToaster.show({
                message: "You've already made one accusation this turn (and if you didn't win it went poorly for you).  You cannot make another."
            })
        } else {
            this.props.dispatch(
                accuseAction( this.state.weapon, this.props.room_coords[ activePlayer.position[0].toString() + activePlayer.position[1].toString() ].toLowerCase(), this.state.character, this.state.player )
            )
        }
        this.setState({ accuse: false })
    }

    socketiotest = () => {
        this.props.socketio.emit('message', 'sending you something')
    }

    handleWeaponChange = (evt) => {
        this.setState({
            weapon: evt.target.value
        })
    }

    handleRoomChange = (evt) => {
        this.setState({
            room: evt.target.value
        })
    }

    handleCharacterChange = (evt) => {
        this.setState({
            character: evt.target.value
        })
    }

    checkMyCards = () => {
        this.setState({
            checkMyCards: true
        })
    }

    endGame = () => {
        browserHistory.push("/")
    }

    componentDidMount() {
        this.setState({
            player: cookies.get(window.location.pathname.split('/')[2])
        })
    }

    render() {
        let gameid = window.location.pathname.split('/')[2]
        let activePlayer = this.props.players[this.props.activePlayer]
        let myTurn = this.props.activePlayer == cookies.get(gameid)
        myTurn = myTurn && this.props.started
        myTurn = myTurn
        let myPlayer = ''
        let myCards = {} 
        try {
            myPlayer = this.props.players[cookies.get(gameid)].characterName
            myCards = this.props.players[cookies.get(gameid)].cards
        } catch(err) {
            console.debug("You must be a spectator.")
            myTurn = false
            myPlayer = 'Spectator'
        }
        let loser = false
        if(this.props.losers != undefined) {
            console.debug(loser, this.props.losers.indexOf(cookies.get(gameid)))
            if(this.props.losers.indexOf(cookies.get(gameid)) > -1) {
                loser = true
            }
        }
        try{
            console.debug(this.props)
            console.debug( this.props.room_coords[ activePlayer.position[0].toString() + activePlayer.position[1].toString() ])
        } catch(err) {}
        return (
            <div>
                <Alert
                    isOpen={this.props.winner != undefined}
                    confirmButtonText="Return to Lobby"
                    onConfirm={this.endGame}>
                        WINNER WINNER CHICKEN DINNER
                </Alert>
                <Alert
                    isOpen={this.state.checkMyCards}
                    confirmButtonText="Close"
                    onConfirm={() => this.setState({checkMyCards: false})}>
                    {
                        myCards != undefined && 
                        Object.entries(myCards).map( (key, value) => {
                            let type = key[1].type
                            let id = key[1].id
                            switch(type) {
                                case 'weapon':
                                    return(
                                        <div className="pt-card pt-elevation-3 pt-interactive">
                                            <span className="pt-icon-standard pt-icon-ninja">   Weapon: <b>{id}</b></span>
                                        </div>
                                    )
                                    break
                                case 'room':
                                    return(
                                        <div className="pt-card pt-elevation-3 pt-interactive">
                                            <span className="pt-icon-standard pt-icon-home">   Room: <b>{id}</b></span>
                                        </div>
                                    )
                                    break
                                case 'character':
                                    return(
                                        <div className="pt-card pt-elevation-3 pt-interactive">
                                            <span className="pt-icon-standard pt-icon-person">   Character: <b>{id}</b></span>
                                        </div>
                                    )
                                    break
                                default: 
                                    return(<div/>)
                            }
                        })
                    }
                </Alert>
                <Alert
                    isOpen={this.state.accuse}
                    confirmButtonText="Accuse!"
                    cancelButtonText="Suggest..."
                    iconName="pt-icon-warning-sign"
                    onCancel={this.suggestPlayer}
                    onConfirm={this.accusePlayer}>
                        <div>
                            <RadioGroup className="radioHeader" label="Weapon" inline={true} selectedValue={this.state.weapon} onChange={this.handleWeaponChange}>
                                <Radio label="Candlestick" value="candlestick" />
                                <Radio label="Knife" value="knife" />
                                <Radio label="Lead Pipe" value="lead pipe" />
                                <Radio label="Revolver" value="revolver" />
                                <Radio label="Rope" value="rope" />
                                <Radio label="Wrench" value="wrench" />
                            </RadioGroup>
                            {/*<RadioGroup className="radioHeader" label="Room" inline={true} selectedValue={this.state.room} onChange={this.handleRoomChange}>
                                <Radio label="Kitchen" value="kitchen" />
                                <Radio label="Ballroom" value="ballroom" />
                                <Radio label="Conservatory" value="conservatory" />
                                <Radio label="Dining Room" value="dining room" />
                                <Radio label="Billiard Room" value="billiard room" />
                                <Radio label="Library" value="library" />
                                <Radio label="Lounge" value="lounge" />
                                <Radio label="Hall" value="hall" />
                                <Radio label="Study" value="study" />
                            </RadioGroup>*/}
                            <RadioGroup className="radioHeader" label="Room" inline={true}>
                                { (activePlayer != undefined && this.props.room_coords != undefined) && <Radio label={this.props.room_coords[ activePlayer.position[0].toString() + activePlayer.position[1].toString() ]} /> }
                            </RadioGroup>
                            <RadioGroup className="radioHeader" label="Character" inline={true} selectedValue={this.state.character} onChange={this.handleCharacterChange}>
                                <Radio label="Mrs. White" value="mrs. white" />
                                <Radio label="Mr. Green" value="mr. green" />
                                <Radio label="Colonel Mustard" value="colonel mustard" />
                                <Radio label="Mrs. Peacock" value="mrs. peacock" />
                                <Radio label="Miss Scarlett" value="miss scarlett" />
                                <Radio label="Professor Plum" value="professor plum" />
                            </RadioGroup>
                        </div>
                </Alert>

                <nav className="pt-navbar pt-dark firstNav">
                    <div className="pt-navbar-group pt-align-left">
                        <div className="pt-navbar-heading" onClick={ () => browserHistory.push("/") }>
                            EN.605.401
                        </div>
                        {
                            this.props.started ? 
                                <div>Game On!</div> :
                                <Button className="pt-icon-play" text="Start Game" onClick={this.startGame} />
                        }
                    </div>
                    <div className="pt-navbar-group pt-align-right">
                        {/*<Button className="pt-icon-test" text="Socket.IO" onClick={this.socketiotest} />*/}
                        <span> Actions </span>
                        <span className='pt-navbar-divider' />
                        <Button className="pt-icon-chevron-up" disabled={!myTurn || this.props.moved} text="Up" onClick={this.moveUp} />
                        <Button className="pt-icon-chevron-down" disabled={!myTurn || this.props.moved} text="Down" onClick={this.moveDown} />
                        <Button className="pt-icon-chevron-left" disabled={!myTurn || this.props.moved} text="Left" onClick={this.moveLeft} />
                        <Button className="pt-icon-chevron-right" disabled={!myTurn || this.props.moved} text="Right" onClick={this.moveRight} />
                        <Button className="pt-icon-fullscreen" disabled={!myTurn || this.props.moved} text="Secret" onClick={this.moveSecret} />
                        <Button className="pt-icon-stop" disabled={!myTurn} text="End Turn" onClick={this.endTurn} />
                        <span className='pt-navbar-divider' />
                        <Button className="pt-icon-follower" disabled={!myTurn || (this.props.suggested && this.props.accused) || loser || activePlayer.position[0] % 2 == 1 || activePlayer.position[1] == 1} text={!loser ? "Accuse / Suggest" : "You Lose!"} onClick={() => this.setState({ accuse: true })} />
                    </div>
                </nav>
                <nav className="pt-navbar pt-dark secondNav">
                    <div className="pt-navbar-group pt-align-left">
                        <div className='pt-navbar-heading'>
                            My Player
                        </div>
                        <span className="pt-navbar-divider" />
                        <div><b>{myPlayer}</b></div>
                        <span className="pt-navbar-divider" />
                        <div className='pt-navbar-heading'>
                            <Button onClick={this.checkMyCards}>My Cards</Button>
                        </div>
                    </div>
                    <div className="pt-navbar-group pt-align-right">
                        <div className="pt-navbar-heading">
                            Active Player
                        </div>
                        <span className='pt-navbar-divider' />
                        <div><b>{activePlayer.playerName}{activePlayer.characterName}</b></div>
                    </div>
                </nav>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        players: state.players,
        activePlayer: state.activePlayer,
        socketio: state.socketio,
        gameid: state.gameid,
        started: state.started,
        winner: state.winner,
        moved: state.moved,
        suggested: state.suggested,
        accused: state.accused,
        losers: state.losers,
        room_coords: state.room_coords,
    }
}

export default connect(mapStateToProps)(Navbar)



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx